import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

import {
  _t,
  getCookie,
  customStyle,
  getDate,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { useCustomHooks } from "../../../../../functions/Hooks";
import { useGeneralHooks } from "../../../../../hooks/generalHooks";

import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MdDelete } from "react-icons/md";

import ManageSidebar from "../ManageSidebar";

import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import { FoodContext } from "../../../../../contexts/Food";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const commonToast = {
  position: "bottom-center",
  autoClose: 10000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  className: "text-center toast-notification",
};

const WastageFoodAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();
  const isEdit = Boolean(id);
  const { roundOffStock, qtyAmountPoints } = useCustomHooks();
  const { hideWastageRecipe } = useGeneralHooks();

  const {
    loading,
    setLoading,
    branchForSearch,
    branchForListSearch,
    ingredientItemForSearch,
  } = useContext(RestaurantContext);

  const { foodForPOS, propertyItemList } = useContext(FoodContext);

  const { setWastageItemList, setWastageItemListForSearch } =
    useContext(UserContext);

  const [newWastage, setNewWastage] = useState({
    documentDate: new Date(),
    document_no: "",
    branch: null,
    variation: "",
    document: "",
    type: "",
    remarks: "",
  });

  const [property, setProperty] = useState(null);
  const [food, setFood] = useState(null);
  const [raw, setRaw] = useState(null);
  const [showVariation, setShowVariation] = useState(false);
  const [variation, setVariation] = useState(null);
  const [optionType, setOptionType] = useState(null);
  const [optionFG, setOptionFG] = useState(null);
  const [newRow, setNewRow] = useState([]);
  const [rowId, setRowId] = useState(0);
  const [fgQty, setFgQty] = useState(1);
  const [recipeDetails, setRecipeDetails] = useState([]);
  const [recipeYield, setRecipeYield] = useState(1);
  const [isAdded, setIsAdded] = useState(false);

  const pageTitle = isEdit ? "Edit Wastage Item" : "Add Wastage Item";

  const resetItemSelection = () => {
    setShowVariation(false);
    setVariation(null);
    setProperty(null);
    setFood(null);
    setNewRow([]);
    setRaw(null);
    setFgQty(1);
    setRecipeDetails([]);
    setRecipeYield(1);
    setIsAdded(false);
  };

  const handleOption = (type) => {
    resetItemSelection();
    setOptionFG(null);
    setOptionType(type);
  };

  const handleRawMaterial = (rawItem) => {
    setRaw(rawItem);
    setNewRow((pre) => [
      ...pre,
      {
        id: rowId,
        item_id: rawItem?.id,
        item_name: rawItem?.name,
        qty: "",
        unit_id: rawItem?.unit_id,
        unit_name: rawItem?.unit,
      },
    ]);
    setRowId(rowId + 1);
  };

  const handleOptionFG = (type) => {
    resetItemSelection();
    setOptionFG(type);
  };

  const extractRecipeData = (item, variationId = "") => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-recipe-report";
    const formData = new FormData();
    formData.append(
      "type_name",
      optionFG === "property_item" ? "Property" : "item",
    );
    formData.append("item_id", item ? item?.id : "");
    formData.append("variation_id", variationId);

    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setLoading(false);
        if (res.data === "Recipe Not Found!") {
          toast.error(res.data);
          return false;
        }
        if (
          res.data[0].recipe_detail !== null &&
          res.data[0].recipe_detail.length > 0
        ) {
          const yieldQty =
            Number(res.data[0]?.qty) > 0 ? Number(res.data[0]?.qty) : 1;
          setRecipeYield(yieldQty);
          setRecipeDetails(res.data[0].recipe_detail);

          const currentQty =
            fgQty !== "" && !isNaN(fgQty) && Number(fgQty) > 0
              ? Number(fgQty)
              : 1;
          const multiplier = currentQty / yieldQty;

          const rows = res.data[0].recipe_detail.map((value) => ({
            id: value?.id,
            item_id: value?.ingredient_id,
            item_name: value?.item_name,
            base_qty: Number(value?.qty) || 0,
            qty: roundOffStock((Number(value?.qty) || 0) * multiplier),
            unit_id: value?.unit_id,
            unit_name: value?.unit_name ? value.unit_name : "Pcs",
          }));
          setNewRow([...rows]);
          setIsAdded(true);
          if (hideWastageRecipe) {
            toast.success(`${_t(t("Item added successfully"))}`, commonToast);
          }
        } else {
          toast.error("Selected item not contain recipe", commonToast);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleFgQtyChange = (e) => {
    setFgQty(e.target.value);
    setIsAdded(false);
  };

  const fetchRecipeForEdit = (itemId, variationId, typeName) => {
    const url = BASE_URL + "/settings/get-recipe-report";
    const formData = new FormData();
    formData.append("type_name", typeName);
    formData.append("item_id", itemId || "");
    formData.append("variation_id", variationId || "");

    axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        if (res.data?.[0]?.recipe_detail?.length > 0) {
          setRecipeYield(
            Number(res.data[0]?.qty) > 0 ? Number(res.data[0]?.qty) : 1,
          );
          setRecipeDetails(res.data[0].recipe_detail);
        }
      })
      .catch(() => {});
  };

  const handleSetItem = (item) => {
    setNewRow([]);
    setShowVariation(false);
    setVariation(null);
    setRecipeDetails([]);
    setIsAdded(false);
    if (optionFG === "property_item") {
      setProperty(item);
    } else {
      setFood(item);
      if (item?.has_variation === "1") {
        setShowVariation(true);
      }
    }
  };

  const handleVariation = (value) => {
    setNewRow([]);
    setVariation(value);
    setRecipeDetails([]);
    setIsAdded(false);
  };

  const handleShowData = () => {
    const selectedItem = optionFG === "property_item" ? property : food;
    if (!selectedItem) {
      toast.error(
        `${_t(t(optionFG === "property_item" ? "Please select property item" : "Please select food"))}`,
        commonToast,
      );
      return;
    }
    if (selectedItem?.has_variation === "1" && !variation) {
      toast.error(`${_t(t("Please select variation"))}`, commonToast);
      return;
    }
    if (!fgQty || Number(fgQty) <= 0) {
      toast.error(`${_t(t("Please enter a valid quantity"))}`, commonToast);
      return;
    }

    if (recipeDetails && recipeDetails.length > 0) {
      const currentQty =
        fgQty !== "" && !isNaN(fgQty) && Number(fgQty) > 0 ? Number(fgQty) : 1;
      const multiplier = currentQty / (recipeYield || 1);
      const rows = recipeDetails.map((value) => ({
        id: value?.id,
        item_id: value?.ingredient_id,
        item_name: value?.item_name,
        base_qty: Number(value?.qty) || 0,
        qty: roundOffStock((Number(value?.qty) || 0) * multiplier),
        unit_id: value?.unit_id,
        unit_name: value?.unit_name ? value.unit_name : "Pcs",
      }));
      setNewRow([...rows]);
      setIsAdded(true);
    } else {
      extractRecipeData(selectedItem, variation ? variation.variation_id : "");
    }
  };

  const handleQty = (index, e) => {
    newRow[index].qty = e.target.value;
    setNewRow([...newRow]);
  };

  const handleSetBranch = (branch) => {
    setNewWastage({ ...newWastage, branch });
  };

  const handleSetRemarks = (remarks) => {
    setNewWastage({ ...newWastage, remarks });
  };

  const handleItemImage = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    setNewWastage((prev) => ({
      ...prev,
      document: file,
    }));
  };

  const getSpecificWastage = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/signal-stock-wastage/" + parseInt(id);
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      const wastageItem = res.data;
      if (!wastageItem) {
        setLoading(false);
        return;
      }

      const documentDate = new Date(wastageItem.document_date);
      const branch =
        branchForListSearch?.[wastageItem.branch_id] ||
        branchForSearch?.find((item) => item.id === wastageItem.branch_id) ||
        null;

      if (wastageItem.type === "food") {
        const foodItem = foodForPOS?.find(
          (item) => item.id === wastageItem.item_id,
        );
        setOptionType("finished_goods");
        setOptionFG("food_item");
        setFood(foodItem || null);
        if (wastageItem.variation_name) {
          setShowVariation(true);
          setVariation({
            variation_id: wastageItem.variation,
            variation_name: wastageItem.variation_name,
          });
        }
        if (wastageItem.qty) {
          setFgQty(wastageItem.qty);
        }
        fetchRecipeForEdit(
          wastageItem.item_id,
          wastageItem.variation || "",
          "item",
        );
      } else if (wastageItem.type === "property") {
        const propertyItem = propertyItemList?.find(
          (item) => item.id === wastageItem.item_id,
        );
        setOptionType("finished_goods");
        setOptionFG("property_item");
        setProperty(propertyItem || null);
        if (wastageItem.qty) {
          setFgQty(wastageItem.qty);
        }
        fetchRecipeForEdit(wastageItem.item_id, "", "Property");
      } else {
        setOptionType("raw_material");
      }

      setNewWastage({
        documentDate,
        document_no: wastageItem.document_identity || "",
        branch,
        variation: wastageItem.variation_name || "",
        document: wastageItem.sw_document || "",
        type: wastageItem.type || "",
        remarks: wastageItem.remarks || "",
      });

      const rowArr = (wastageItem.stock_wastage_details || []).map(
        (item, index) => ({
          id: item.id || index,
          item_id: item.item_id || item.ingredient_id || item.id,
          item_name: item.item_name,
          qty: roundOffStock(item.qty),
          unit_id: item.unit_id,
          unit_name: item.unit_name || "Pcs",
        }),
      );
      setNewRow(rowArr);
      setRowId(rowArr.length);
      if (wastageItem.type === "food" || wastageItem.type === "property") {
        setIsAdded(true);
      }
      setLoading(false);
    } catch (error) {
      console.log("Error==>", error);
      setLoading(false);
      toast.error(`${_t(t("Please try again later"))}`, commonToast);
    }
  };

  useEffect(() => {
    if (isEdit && branchForSearch) {
      getSpecificWastage();
    }
  }, [id, branchForSearch, foodForPOS, propertyItemList]);

  const wastageAxios = async (formData) => {
    setLoading(true);
    const url = isEdit
      ? BASE_URL + "/settings/stock-wastage/" + id
      : BASE_URL + "/settings/stock-wastage";

    const headers = {
      Authorization: `Bearer ${getCookie()}`,
    };

    try {
      const res = await axios.post(url, formData, { headers });

      setWastageItemList(res.data[0]);
      setWastageItemListForSearch(res.data[1]);
      setLoading(false);
      toast.success(
        `${_t(t(isEdit ? "Wastage has been updated" : "Wastage has been added"))}`,
        commonToast,
      );
      history.push("/dashboard/manage/stock/wastage-food");
    } catch (error) {
      console.log("check error==>", error);
      setLoading(false);
      if (error.response?.data?.status === 0) {
        toast.error(error.response.data.message, commonToast);
        return false;
      }
      toast.error(`${_t(t("Please try again later"))}`, commonToast);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (optionType === "finished_goods" && (!isAdded || !newRow?.length)) {
      handleShowData();
      return;
    }
    if (
      newRow !== null &&
      newRow.length > 0 &&
      newWastage.documentDate &&
      newWastage.branch
    ) {
      if (optionType === "finished_goods" && (!fgQty || Number(fgQty) <= 0)) {
        toast.error(`${_t(t("Please enter a valid quantity"))}`, commonToast);
        return;
      }

      const duplicate = {};
      const duplicateItem = [];
      const tableData = newRow.map((item) => {
        if (duplicate[item.item_id]) {
          duplicateItem.push(item);
        }
        duplicate[item.item_id] = true;
        const { id: _rowId, base_qty: _base_qty, ...newItem } = item;
        return newItem;
      });

      const formData = new FormData();

      const method = id ? "put" : "post";

      //formData.append("food_group_id", newItem.item_group.id);
      formData.append("_method", method);

      formData.append("document_date", getDate(newWastage?.documentDate));

      formData.append("branch_id", newWastage?.branch?.id);

      formData.append(
        "type",
        optionType === "raw_material"
          ? "raw"
          : optionFG === "property_item"
            ? "property"
            : "food",
      );

      formData.append(
        "item_id",
        optionType === "raw_material"
          ? 0
          : optionFG === "property_item"
            ? property?.id
            : food?.id,
      );

      formData.append("variation", variation ? variation.variation_id : "");

      formData.append(
        "variation_name",
        variation ? variation.variation_name : "",
      );

      formData.append(
        "qty",
        optionType === "finished_goods" ? parseFloat(fgQty) || 1 : 0,
      );

      formData.append("items", JSON.stringify(tableData));

      formData.append("remarks", newWastage?.remarks || "");
      if (newWastage?.document && typeof newWastage.document !== "string") {
        formData.append("sw_document", newWastage.document);
      }
      if (optionType === "raw_material" && duplicateItem?.length) {
        toast.error(
          `${_t(t(`Duplicate item ${duplicateItem[0].item_name} found`))}`,
          commonToast,
        );
        return;
      }
      handleSaveConfirmation(formData);
    } else {
      toast.error(
        `${_t(t("Please fill all the required fields"))}`,
        commonToast,
      );
    }
  };

  const handleSaveConfirmation = (formData) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">
              {_t(
                t(
                  isEdit
                    ? "You want to update this?"
                    : "You want to save this?",
                ),
              )}
            </p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  wastageAxios(formData);
                  onClose();
                }}
              >
                {_t(t(isEdit ? "Yes, update it!" : "Yes, save it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const handleDltHandler = (rowKey) => {
    setNewRow(newRow.filter((item) => rowKey !== item.id));
  };

  const documentFileName =
    newWastage?.document && typeof newWastage.document !== "string"
      ? newWastage.document.name
      : newWastage?.document
        ? "Attached document"
        : "";

  return (
    <>
      <Helmet>
        <title>{_t(t(pageTitle))}</title>
      </Helmet>

      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>

            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    <CustomSpinLoader loading={loading} />
                    <div key="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t(pageTitle))}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <form
                        className="card border-0 shadow-sm mx-3 mb-4 table-text"
                        onSubmit={handleSubmit}
                      >
                        <div className="card-body p-3">
                          {/* Row 1: Document Metadata & Remarks */}
                          <div className="row g-2 align-items-end mb-2">
                            <div className="form-group col-xl-2 col-lg-2 col-md-3 col-sm-6 mb-2">
                              <label
                                htmlFor="document_no"
                                className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                style={{ fontSize: "11px", color: "#000" }}
                              >
                                {_t(t("Document no"))}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                readOnly
                                type="text"
                                className="form-control form-control-sm table-text"
                                id="document_no"
                                name="document_no"
                                value={newWastage.document_no || ""}
                                placeholder="Auto no"
                                required={!isEdit}
                                style={{ height: "34px" }}
                              />
                            </div>

                            <div className="form-group col-xl-2 col-lg-2 col-md-3 col-sm-6 mb-2">
                              <label
                                htmlFor="document_date"
                                className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                style={{ fontSize: "11px", color: "#000" }}
                              >
                                {_t(t("Document Date"))}
                                <span className="text-danger">*</span>
                              </label>
                              <DatePicker
                                selected={newWastage.documentDate || ""}
                                onChange={(e) =>
                                  setNewWastage({
                                    ...newWastage,
                                    documentDate: e,
                                  })
                                }
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                className="form-control form-control-sm table-text"
                                placeholderText={_t(t("document date"))}
                                shouldCloseOnSelect={false}
                              />
                            </div>

                            <div className="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6 mb-2">
                              <label
                                htmlFor="branch"
                                className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                style={{ fontSize: "11px", color: "#000" }}
                              >
                                {_t(t("Branch"))}
                                <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={branchForSearch ? branchForSearch : []}
                                components={makeAnimated()}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                value={newWastage.branch || null}
                                classNamePrefix="select"
                                onChange={handleSetBranch}
                                maxMenuHeight="200px"
                                styles={customStyle}
                                placeholder={
                                  _t(t("Please select a branch")) + ".."
                                }
                              />
                            </div>

                            <div className="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6 mb-2">
                              <label
                                htmlFor="remarks"
                                className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                style={{ fontSize: "11px", color: "#000" }}
                              >
                                {_t(t("Remarks"))}
                              </label>
                              <input
                                type="text"
                                className="form-control form-control-sm table-text"
                                id="remarks"
                                name="remarks"
                                onChange={(e) =>
                                  handleSetRemarks(e.target.value)
                                }
                                value={newWastage.remarks}
                                placeholder={_t(t("Remarks"))}
                                style={{ height: "34px" }}
                              />
                            </div>

                            <div className="form-group col-xl-2 col-lg-2 col-md-6 col-sm-6 mb-2">
                              <label
                                htmlFor="doc"
                                className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                style={{ fontSize: "11px", color: "#000" }}
                              >
                                {_t(t("Attach Doc"))}
                              </label>
                              <div
                                className="d-flex align-items-center"
                                style={{ height: "34px" }}
                              >
                                <input
                                  accept="image/*,.pdf,.jpg,.jpeg,.png,.gif,.mp4,.webm"
                                  type="file"
                                  className="d-none"
                                  id="doc"
                                  name="document"
                                  onChange={handleItemImage}
                                />
                                <label
                                  htmlFor="doc"
                                  className="btn btn-sm btn-outline-secondary mb-0 py-1 px-2 text-nowrap mr-1 cursor-pointer d-flex align-items-center"
                                  style={{
                                    fontSize: "11px",
                                    height: "34px",
                                    color: "#000",
                                    borderColor: "#6c757d",
                                  }}
                                >
                                  <i className="fa fa-paperclip mr-1"></i>{" "}
                                  {newWastage?.document
                                    ? _t(t("Change"))
                                    : _t(t("Choose"))}
                                </label>
                                {newWastage?.document && (
                                  <span
                                    className="badge badge-light border text-truncate d-inline-flex align-items-center px-1"
                                    style={{
                                      maxWidth: "5.5rem",
                                      fontSize: "11px",
                                      height: "34px",
                                      color: "#000",
                                    }}
                                    title={documentFileName}
                                  >
                                    <span className="text-truncate">
                                      {documentFileName}
                                    </span>
                                    <span
                                      onClick={() =>
                                        setNewWastage({
                                          ...newWastage,
                                          document: null,
                                        })
                                      }
                                      className="text-danger ml-1 cursor-pointer font-weight-bold"
                                      style={{
                                        fontSize: "14px",
                                        lineHeight: "1",
                                      }}
                                    >
                                      &times;
                                    </span>
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Row 2: Type, Category, Item, Quantity & Action in One Straight Line */}
                          <div className="row g-2 align-items-end mb-2">
                            <div className="form-group col-xl-3 col-lg-3 col-md-5 mb-2">
                              <label
                                className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                style={{ fontSize: "11px", color: "#000" }}
                              >
                                {_t(t("Type"))}{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <div
                                className="d-flex align-items-center bg-light rounded px-2 border"
                                style={{ height: "34px" }}
                              >
                                <div className="form-check custom-radio mb-0 d-flex align-items-center mr-3">
                                  <input
                                    type="radio"
                                    className="form-check-input cursor-pointer mt-0"
                                    id="raw_material"
                                    name="raw_material"
                                    value="raw_material"
                                    onChange={(e) =>
                                      handleOption(e.target.value)
                                    }
                                    checked={optionType === "raw_material"}
                                  />
                                  <label
                                    className={`form-check-label cursor-pointer ml-1 mb-0 sm-text ${optionType === "raw_material" ? "font-weight-bold" : ""}`}
                                    htmlFor="raw_material"
                                    style={{ fontSize: "12px", color: "#000" }}
                                  >
                                    {_t(t("Raw Material"))}
                                  </label>
                                </div>

                                <div className="form-check custom-radio mb-0 d-flex align-items-center">
                                  <input
                                    type="radio"
                                    className="form-check-input cursor-pointer mt-0"
                                    id="finished_goods"
                                    name="finished_goods"
                                    value="finished_goods"
                                    onChange={(e) =>
                                      handleOption(e.target.value)
                                    }
                                    checked={optionType === "finished_goods"}
                                  />
                                  <label
                                    className={`form-check-label cursor-pointer ml-1 mb-0 sm-text ${optionType === "finished_goods" ? "font-weight-bold" : ""}`}
                                    htmlFor="finished_goods"
                                    style={{ fontSize: "12px", color: "#000" }}
                                  >
                                    {_t(t("Finished Goods"))}
                                  </label>
                                </div>
                              </div>
                            </div>

                            {optionType === "finished_goods" && (
                              <>
                                <div className="form-group col-xl-2 col-lg-2 col-md-4 mb-2">
                                  <label
                                    className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                    style={{ fontSize: "11px", color: "#000" }}
                                  >
                                    {_t(t("Category"))}{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div
                                    className="d-flex align-items-center bg-light rounded px-2 border"
                                    style={{ height: "34px" }}
                                  >
                                    <div className="form-check custom-radio mb-0 d-flex align-items-center mr-2">
                                      <input
                                        type="radio"
                                        className="form-check-input cursor-pointer mt-0"
                                        id="food_item"
                                        name="food_item"
                                        value="food_item"
                                        onChange={(e) =>
                                          handleOptionFG(e.target.value)
                                        }
                                        checked={optionFG === "food_item"}
                                      />
                                      <label
                                        className={`form-check-label cursor-pointer ml-1 mb-0 sm-text ${optionFG === "food_item" ? "font-weight-bold" : ""}`}
                                        htmlFor="food_item"
                                        style={{
                                          fontSize: "12px",
                                          color: "#000",
                                        }}
                                      >
                                        {_t(t("Food"))}
                                      </label>
                                    </div>

                                    <div className="form-check custom-radio mb-0 d-flex align-items-center">
                                      <input
                                        type="radio"
                                        className="form-check-input cursor-pointer mt-0"
                                        id="property_item"
                                        name="property_item"
                                        value="property_item"
                                        onChange={(e) =>
                                          handleOptionFG(e.target.value)
                                        }
                                        checked={optionFG === "property_item"}
                                      />
                                      <label
                                        className={`form-check-label cursor-pointer ml-1 mb-0 sm-text ${optionFG === "property_item" ? "font-weight-bold" : ""}`}
                                        htmlFor="property_item"
                                        style={{
                                          fontSize: "12px",
                                          color: "#000",
                                        }}
                                      >
                                        {_t(t("Property"))}
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                <div className="form-group col-xl-4 col-lg-3 col-md-5 mb-2">
                                  <label
                                    htmlFor="fg_item_select"
                                    className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                    style={{ fontSize: "11px", color: "#000" }}
                                  >
                                    {_t(
                                      t(
                                        optionFG === "food_item"
                                          ? "Food Item"
                                          : optionFG === "property_item"
                                            ? "Property Item"
                                            : "Item",
                                      ),
                                    )}{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <Select
                                    id="fg_item_select"
                                    options={
                                      optionFG === "food_item"
                                        ? foodForPOS || []
                                        : optionFG === "property_item"
                                          ? propertyItemList || []
                                          : []
                                    }
                                    isDisabled={!optionFG}
                                    components={makeAnimated()}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    value={
                                      optionFG === "food_item" ? food : property
                                    }
                                    classNamePrefix="select"
                                    onChange={handleSetItem}
                                    maxMenuHeight="200px"
                                    styles={customStyle}
                                    placeholder={
                                      optionFG === "food_item"
                                        ? _t(t("Please select food")) + ".."
                                        : optionFG === "property_item"
                                          ? _t(
                                              t("Please select property item"),
                                            ) + ".."
                                          : _t(t("Select category first")) +
                                            ".."
                                    }
                                  />
                                </div>

                                <div
                                  className="form-group col-xl-1 col-lg-2 col-md-2 col-sm-4 mb-2"
                                  style={{ minWidth: "90px" }}
                                >
                                  <label
                                    htmlFor="fg_qty"
                                    className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                    style={{ fontSize: "11px", color: "#000" }}
                                  >
                                    {_t(t("Quantity"))}{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    step={qtyAmountPoints()}
                                    min="1"
                                    className="form-control form-control-sm table-text text-center"
                                    id="fg_qty"
                                    name="fg_qty"
                                    onKeyDown={(evt) =>
                                      ["e", "E", "+", "-"].includes(evt.key) &&
                                      evt.preventDefault()
                                    }
                                    onWheel={(e) => e.target.blur()}
                                    value={fgQty}
                                    onChange={handleFgQtyChange}
                                    placeholder="1"
                                    required
                                    style={{ height: "34px" }}
                                  />
                                </div>

                                <div className="form-group col-auto mb-2">
                                  <button
                                    type="button"
                                    disabled={loading || !optionFG}
                                    className="btn btn-sm btn-primary rounded px-3 font-weight-bold"
                                    onClick={handleShowData}
                                    style={{
                                      height: "34px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {_t(t("Add"))}
                                  </button>
                                </div>
                              </>
                            )}

                            {optionType === "raw_material" && (
                              <div className="form-group col-xl-5 col-lg-6 col-md-7 mb-2">
                                <label
                                  className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                  style={{ fontSize: "11px", color: "#000" }}
                                >
                                  {_t(t("Ingredient Item"))}{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <Select
                                  options={
                                    ingredientItemForSearch
                                      ? ingredientItemForSearch
                                      : []
                                  }
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={raw}
                                  classNamePrefix="select"
                                  onChange={handleRawMaterial}
                                  maxMenuHeight="200px"
                                  styles={customStyle}
                                  placeholder={
                                    _t(t("Please select ingredients")) + ".."
                                  }
                                />
                              </div>
                            )}
                          </div>

                          {/* Variation strip */}
                          {showVariation && (
                            <div className="row g-2 mb-2">
                              <div className="col-12">
                                <div className="d-flex align-items-center flex-wrap py-1 px-3 bg-light rounded border">
                                  <span
                                    className="font-weight-bold mr-3 text-dark text-uppercase"
                                    style={{
                                      fontSize: "11px",
                                      letterSpacing: "0.3px",
                                      color: "#000",
                                    }}
                                  >
                                    <i className="fa fa-tags mr-1"></i>{" "}
                                    {_t(t("Select Variation"))}:
                                  </span>
                                  <div className="d-flex align-items-center flex-wrap">
                                    {food?.variation_recipe?.map((item) => (
                                      <div
                                        className="form-check custom-radio mb-0 d-flex align-items-center mr-3 my-1"
                                        key={item.food_with_variation_id}
                                      >
                                        <input
                                          className="form-check-input cursor-pointer mt-0"
                                          type="radio"
                                          name="variations"
                                          id={item.variation_name}
                                          checked={
                                            variation?.variation_name ===
                                            item.variation_name
                                          }
                                          onChange={() => handleVariation(item)}
                                          required
                                        />
                                        <label
                                          className={`form-check-label cursor-pointer ml-1 mb-0 sm-text text-capitalize ${
                                            variation?.variation_name ===
                                            item.variation_name
                                              ? "font-weight-bold"
                                              : ""
                                          }`}
                                          htmlFor={item.variation_name}
                                          style={{
                                            fontSize: "12px",
                                            color: "#000",
                                          }}
                                        >
                                          {item.variation_name}
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Table Section */}
                          {!(hideWastageRecipe && optionType === "finished_goods") && (
                            <div
                              className="table-responsive border rounded bg-white mt-1 pr-1"
                              style={{ maxHeight: "22rem", overflow: "auto" }}
                            >
                              <table className="table table-bordered-sm table-hover mb-0">
                                <thead
                                  className="thead-light align-middle sticky-top"
                                  style={{ zIndex: 1 }}
                                >
                                  <tr>
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border py-2"
                                      style={{ width: "45%" }}
                                    >
                                      <span style={{ fontWeight: 600 }}>
                                        {_t(t("Item"))}
                                      </span>
                                    </th>
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border py-2"
                                      style={{ width: "25%" }}
                                    >
                                      <span style={{ fontWeight: 600 }}>
                                        {_t(t("Qty"))}
                                      </span>
                                    </th>
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border py-2"
                                      style={{
                                        width:
                                          optionType === "raw_material"
                                            ? "20%"
                                            : "30%",
                                      }}
                                    >
                                      <span style={{ fontWeight: 600 }}>
                                        {_t(t("Unit"))}
                                      </span>
                                    </th>
                                    {optionType === "raw_material" && (
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border py-2"
                                        style={{ width: "10%" }}
                                      >
                                        <span style={{ fontWeight: 600 }}>
                                          {_t(t("Action"))}
                                        </span>
                                      </th>
                                    )}
                                  </tr>
                                </thead>
                                {newRow && newRow.length > 0 ? (
                                  <tbody className="align-middle">
                                    {newRow.map((item, index) => (
                                      <tr
                                        className="align-middle"
                                        key={item.id || index}
                                      >
                                        <td className="table-text text-capitalize align-middle text-center">
                                          {item.item_name}
                                        </td>
                                        <td className="table-text text-capitalize align-middle text-center">
                                          <input
                                            type="number"
                                            step={qtyAmountPoints()}
                                            min="0"
                                            onKeyDown={(evt) =>
                                              [
                                                "e",
                                                "E",
                                                "+",
                                                "-",
                                                "ArrowUp",
                                                "ArrowDown",
                                              ].includes(evt.key) &&
                                              evt.preventDefault()
                                            }
                                            onWheel={(e) => e.target.blur()}
                                            className="form-control text-center table-Input table-text py-0"
                                            style={{ height: "30px" }}
                                            id={item.id}
                                            name={item.id}
                                            onChange={(e) => handleQty(index, e)}
                                            value={item.qty || ""}
                                            placeholder="Qty"
                                            required
                                            disabled={
                                              optionType === "finished_goods"
                                            }
                                          />
                                        </td>
                                        <td className="table-text text-capitalize align-middle text-center">
                                          {item.unit_name}
                                        </td>
                                        {optionType === "raw_material" && (
                                          <td
                                            className="table-text text-capitalize align-middle text-center"
                                            style={{ width: "10%" }}
                                          >
                                            <MdDelete
                                              className="text-danger"
                                              style={{
                                                cursor: "pointer",
                                                fontSize: "20px",
                                              }}
                                              onClick={() =>
                                                handleDltHandler(item.id)
                                              }
                                            />
                                          </td>
                                        )}
                                      </tr>
                                    ))}
                                  </tbody>
                                ) : (
                                  <tbody>
                                    <tr>
                                      <td
                                        colSpan={
                                          optionType === "raw_material" ? 4 : 3
                                        }
                                        className="text-center py-4 text-muted sm-text"
                                      >
                                        <i className="fa fa-info-circle mr-1"></i>{" "}
                                        {_t(
                                          t(
                                            "No items added yet. Select items above to populate table.",
                                          ),
                                        )}
                                      </td>
                                    </tr>
                                  </tbody>
                                )}
                              </table>
                            </div>
                          )}

                          {/* Footer Action Buttons */}
                          <div className="d-flex justify-content-end align-items-center mt-3 pt-2 border-top">
                            <button
                              type="button"
                              className="btn btn-sm btn-light border rounded px-3 mr-2 font-weight-bold"
                              onClick={() =>
                                history.push(
                                  "/dashboard/manage/stock/wastage-food",
                                )
                              }
                              style={{ height: "34px" }}
                            >
                              <i
                                className="fa fa-arrow-left mr-1"
                                aria-hidden="true"
                              ></i>{" "}
                              {_t(t("Back"))}
                            </button>
                            <button
                              disabled={loading}
                              type="submit"
                              className="btn btn-sm btn-primary rounded px-4 font-weight-bold"
                              style={{ height: "34px" }}
                            >
                              <i
                                className="fa fa-floppy-o mr-1"
                                aria-hidden="true"
                              ></i>{" "}
                              {_t(t(isEdit ? "Update" : "Save"))}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default WastageFoodAction;
